import { Fragment } from 'react'
import styled from 'styled-components'
import { type UniversalCategory } from '@/features/shop/services/UniversalCategories/types'
import { Body } from '@shipt/design-system-typography'
import { ChevronRightIcon } from '@shipt/design-system-icons'
import {
  urlBuilder,
  getUniversalCategories,
} from '@/features/shop/services/UniversalCategories/utils'
import { NextLink } from '@/features/shared/elements/Link'
import { useSearchQueryParams } from '@/features/shared/hooks/search'
import { routes } from '@shared/constants/routes'
import { Row } from '@shipt/design-system-layouts'

type Props = {
  categories: UniversalCategory[]
  includeCategoriesLink?: boolean
}

export const CategoryBreadcrumb = ({ categories, includeCategoriesLink = false }: Props) => {
  const searchParams = useSearchQueryParams()
  const zipParam = String(searchParams.zip ?? '')
  const universalCategories = getUniversalCategories()
  if (!categories.length) return null
  return (
    <nav aria-label="breadcrumb">
      <Row align="center" marginBottom="xxl" wrap>
        {!!includeCategoriesLink && (
          <>
            <NextLink href={routes.UNGATED_CATEGORY_HUB.url}>
              <Breadcrumb>Categories</Breadcrumb>
            </NextLink>
            <RightArrow size="sm" inherit />
          </>
        )}
        {categories.map((category, index) => {
          const isLastItem = index === categories.length - 1
          return (
            <Fragment key={category.id}>
              <NextLink
                href={urlBuilder({
                  universalCategories,
                  category,
                  zip: zipParam,
                })}
              >
                <Breadcrumb variant={isLastItem ? 'secondary' : 'primary'}>
                  {category.name}
                </Breadcrumb>
              </NextLink>
              {!isLastItem && <RightArrow size="sm" inherit />}
            </Fragment>
          )
        })}
      </Row>
    </nav>
  )
}

const Breadcrumb = styled(Body)`
  display: inline;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.content.action.primary};
  }
`

const RightArrow = styled(ChevronRightIcon)`
  margin: 0 0.25rem;
`
